import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import "./assets/css/font.css";
import "./assets/css/styles.scss";
import "./plugins/axios";

import Iconify from "./components/Iconify";
import Divcard from "./components/Divcard";
import VueSignaturePad from "vue-signature-pad";
import axios from "axios";
import { apiDomain } from "./store/constants";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
Vue.use(HighchartsVue);

Vue.use(require("vue-moment"));
Vue.use(VueSignaturePad);
Vue.component("Iconify", Iconify);
Vue.component("divcard", Divcard);

Vue.config.productionTip = false;

// apiFire using dispatch
Vue.prototype.$apiFire = async (
  dispatch,
  payload = undefined,
  fullResponse = false
) => {
  // check token
  // if (!getCookie__c('session_login') || !JSON.parse(getCookie__c('session_login')).token) {
  //   return reLogin()
  // }
  store.commit("General/setLoading");
  await axios({
    url: apiDomain + "sanctum/csrf-cookie",
    method: "GET",
  });

  let res = await store.dispatch(dispatch, {
    payload,
    // token: JSON.parse(getCookie__c('session_login')).token,
    fullResponse,
  });
  store.commit("General/setLoading", false);
  return res;
};

export function reLogin(text) {
  store.commit("General/setModal", {
    title: "Oops!",
    buttonText: "ยืนยัน",
    showCancel: false,
    text,
    action: () => {
      store.commit("Auth/clearUserInfo");
      window.location.href = "/";
    },
  });
}

export function checkAndReturn(data, res) {
  if (res.data && res.status === 200) {
    if (data.fullResponse) return res.data;
    return res.data.data;
  } else {
    if (res.status === 401) {
      return reLogin(res.data.message);
    }
    if (res.status === 422) {
      return Object.values(res.data.errors);
    }
    if (res.status === 500) {
      store.commit("General/setModal", {
        title: "Something went wrong!",
        showCancel: false,
        theme: "error",
        text: res.data.message,
      });
    }
    return false;
  }
}

const v = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
});

// when router is ready then render app
router.onReady(() => {
  v.$mount("#app");
});
